// @flow
import styled from 'styled-components';

const heightItem = 3;
const heightAddAndCancel = 2.2;
const easeOutQuint = 'cubic-bezier(0.23, 1, 0.32, 1)';

export const AddEventContainer = styled.div`
    align-items: center;
    border: ${p =>
        p.isDetailVisible ? `solid 1px ${p.theme.secondaryMedium}` : `dashed 2px ${p.theme.secondaryMedium}`};
    border-radius: 1em;
    display: flex;
    flex-direction: column;
    height: ${p => (p.isDetailVisible ? p.numberElements * heightItem + heightAddAndCancel : heightAddAndCancel)}em;
    justify-content: center;
    overflow: hidden;
    transition: all 0.3s ${easeOutQuint};

    & > svg > g {
        fill: ${p => p.theme.mainBrandColor};
    }
`;

export const ShowDetail = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    height: ${heightAddAndCancel}em;
    justify-content: center;
`;

export const AllowedTypeItem = styled.div`
    align-items: center;
    border-bottom: solid 1px ${p => p.theme.secondaryMedium};
    cursor: ${p => (p.disabled ? 'inherit' : 'pointer')};
    display: flex;
    height: ${heightItem}em;
    width: 100%;

    & > span {
        opacity: ${p => (p.disabled ? 0.5 : 1)};
        font-size: 1.2em;
    }

    &:hover {
        background-color: ${p => (p.disabled ? 'inherit' : p.theme.secondaryLight)};
    }
`;

export const AddEventIcon = styled.div`
    display: flex;
    height: ${heightItem}em;
    justify-content: center;
    opacity: ${p => (p.disabled ? 0.3 : 1)};
    padding: 0.4em;
    width: 5em;
`;

export const CancelAdding = styled.div`
    align-items: center;
    background-color: ${p => p.theme.secondaryLight};
    color: ${p => p.theme.mainBrandColor};
    cursor: pointer;
    display: flex;
    height: ${heightAddAndCancel}em;
    justify-content: center;
    width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/action-detail/add-event/styles.js